import React from 'react';

import '../../styles/common/long-text.scss';

const LongText = (props) => (
  <div className={`long-text`}>
    { props.children }
  </div>
);

export default LongText;